<template>
    <v-tabs
        v-model="selectedTab"
        height="2.5rem"
        background-color="transparent"
        class="promo-tabs"
        active-class="promo-tabs__tab--active"
        hide-slider
    >
        <template v-for="tab in tabs" :key="`tab-${tab.label}`">
            <!-- Used to fill and style the space between tabs. -->
            <v-tab
                :disabled="tab.disabled"
                class="promo-tabs__tab"
                :to="tab.path"
                :class="tab.class"
            >
                {{ toSentenceCase(tab.label) }}
            </v-tab>
            <div class="promo-tabs__spacer" />
        </template>
    </v-tabs>

    <!-- Used to fill and style the remaining space from the last tab to the end of the tabs container. -->
    <div class="promo-tabs__filler" />
    <v-window v-model="selectedTab">
        <template v-if="!routerTab">
            <v-window-item
                v-for="tab in tabs"
                :key="`tab-item-${tab.label}`"
                :transition="false"
                :reverse-transition="false"
                :active-class="tab.class"
                class="tab"
            >
                <component :is="tab.component" />
            </v-window-item>
        </template>
        <template v-else>
            <router-view />
        </template>
    </v-window>
</template>

<script>
import { findIndex, includes } from 'lodash';

export default {
    props: {
        tabs: {
            type: Array,
            required: true,
        },
        routerTab: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selectedTab: 0,
        };
    },
    created() {
        this.setDefaultTab();
    },
    methods: {
        setDefaultTab() {
            const routeName = this.$route.name;
            const tabToOpen = findIndex(this.tabs, tab => includes(tab.routeNames, routeName));

            this.selectedTab = tabToOpen;
        },
    },
};
</script>

<style scoped lang="scss">
:deep(.v-tabs-items) {
    background-color: transparent !important;
}
</style>
